module.exports = __webpack_public_path__ + "media/images/city/087-pyramids-ae06044d23a0304dda65c7271e77c9e4.svg";